import { render } from "./ModalAvisoGenerico.vue?vue&type=template&id=37a0865a&scoped=true"
import script from "./ModalAvisoGenerico.vue?vue&type=script&lang=js"
export * from "./ModalAvisoGenerico.vue?vue&type=script&lang=js"

import "./ModalAvisoGenerico.vue?vue&type=style&index=0&id=37a0865a&scoped=true&lang=css"

import exportComponent from "../../../node_modules/vue-loader/dist/exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['render',render],['__scopeId',"data-v-37a0865a"]])

export default __exports__